import {useRouter} from "vue-router";
import config from "@/composables/Config";

export const getToken = () => {
    const storageToken = localStorage.getItem(config.general.token);
    const paramToken = (window.location.hash.split('?')[1] || '').split('&').reduce((acc, param) => {
        const [key, value] = param.split('=');
        return key === 't' ? value : acc;
    }, null);
    return paramToken ?? storageToken;
}

export const setToken = (token) => {
    localStorage.setItem(config.general.token, token);
}

export const clearToken = () => {
    localStorage.removeItem(config.general.token);
}

export const isValidUrl = (urlString) => {
    let urlPattern = new RegExp('^(https?:\\/\\/)?' + // validate protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // validate domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // validate OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // validate port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // validate query string
        '(\\#[-a-z\\d_]*)?$', 'i'); // validate fragment locator
    return !!urlPattern.test(urlString);
}

export const goToPath = (id) => {
    const router = useRouter();
    router.push({name: 'content', params: {id: id}});
}

export const redirectToLogin = (routeFullPath = '', extraParams = {}) => {
    localStorage.removeItem(config.general.token);
    localStorage.setItem(config.general.intended_url, routeFullPath);
    let currentUrl = window.location.origin;
    let loginUrl = '';

    if (process.env.NODE_ENV === 'development') {
        loginUrl = process.env.LOGIN_URL + '/dlogin';
        if (currentUrl.includes("localhost")) {
            extraParams.serve = 1;
        }
    } else {
        loginUrl = currentUrl.replace("https://", "https://api.") + '/dlogin';
    }

    let queryString = '';
    if (Object.keys(extraParams).length > 0) {
        const paramStrings = Object.entries(extraParams).map(([key, value]) => `${key}=${value}`);
        queryString = '?' + paramStrings.join('&');
    }

    window.location.href = `${loginUrl}${queryString}`;
}

export const attachCssFile = (cssFileName) => {
    var element = document.createElement('link');
    element.setAttribute('rel', 'stylesheet');
    element.setAttribute('type', 'text/css');
    element.setAttribute('href', `${cssFileName}.css`);
    document.getElementsByTagName('head')[0].appendChild(element);
}

export const setReturnPath = (path) => {
    localStorage.setItem(config.general.return_path, path)
}

export const getReturnPath = () => {
    return localStorage.getItem(config.general.return_path)
}

export const clearReturnPath = () => {
    localStorage.removeItem(config.general.return_path)
}

